import { Address } from '@app/types';
import { APIForms } from './api-forms';

type JSONPathItem<T> = {
  Id: number;
  CreatedAt: string;
  LastModifiedAt: string | null;
  Data: T;
} | null;

type JSONPathResponse<T> = {
  Itens: (JSONPathItem<T> | null)[];
  Start: number;
  Count: number;
  TotalItens: number;
  data: null;
};

export type SharedAddress = Address & {
  userDeviceId: string;
  savedByRestaurantId: string;
  savedByRestaurantName: string;
  lastUsageAt: number;
  lastUsageByRestaurantId: string;
  lastUsageByRestaurantName: string;
};

export class APIAddressesShared {
  private static path(cityId: string | number) {
    return `addresses-shared-${cityId}`;
  }

  static async fetchByDeviceId(deviceId: string, cityId: string | number) {
    const { data } = await APIForms.jsonPath<JSONPathResponse<SharedAddress>>(
      this.path(cityId),
      `@.Data.userDeviceId==\'${deviceId}\'`
    );
    return data.Itens[0] ?? null;
  }

  static async save(sharedAddress: SharedAddress) {
    const cityId = sharedAddress.city.Cod_Cidade;
    const previousData = await this.fetchByDeviceId(sharedAddress.userDeviceId, cityId);
    if (!previousData) {
      await APIForms.post(`/${this.path(cityId)}`, sharedAddress);
    } else {
      await APIForms.put(`/${this.path(cityId)}`, previousData.Id, { ...previousData.Data, ...sharedAddress });
    }
  }
}
